import React, { useEffect, useRef } from 'react';
import '../AddFire.scss';
import left from '../../../../assets/icons/left.png';
import * as turf from "@turf/turf";
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import { drawStyle } from '../../../drawStyles.js';

export default function AddPerimeter(props) {
    const { 
        setStage, 
        map, 
        perimeter, 
        setPerimeter 
    } = props;

    const draw = useRef();

    useEffect(() => {
        if (!draw.current) {
            draw.current = new MapboxDraw({
                displayControlsDefault: false,
                controls: { polygon: true },
                styles: drawStyle,
            });
        }

        if (map.current && !map.current._controls.find((control) => control === draw.current)) {
            map.current.addControl(draw.current);
        }

        if (perimeter && draw.current) {
            draw.current.deleteAll(); 
            draw.current.add(perimeter); 
            draw.current.changeMode('simple_select'); 
        } else if (draw.current) {
            draw.current.changeMode('draw_polygon');
        }

        const handleUpdate = () => {
            const data = draw.current.getAll();
            const area = turf.area(data);
            const rounded_area = Math.round(area * 100) / 100;
            data.features[0].properties = { area: rounded_area };
            setPerimeter(data);
        };

        map.current.on('draw.create', handleUpdate);
        map.current.on('draw.update', handleUpdate);

        return () => {
            map.current.off('draw.create', handleUpdate);
            map.current.off('draw.update', handleUpdate);

            if (map.current._controls.find((control) => control === draw.current)) {
                map.current.removeControl(draw.current);
            }
        };
    }, [map, perimeter, setPerimeter]);

    return (
        <div className='add-fire-content-instructions' style={{ marginTop: '0.1rem' }}>
            <div
                className='add-fire-back-btn'
                onClick={() => {
                    setStage('add-fire');
                    setPerimeter(null);
                    draw.current.deleteAll();
                }}
            >
                <img src={left} className='add-fire-back-btn-icon' />
                Back
            </div>
            <div className='add-fire-content-instructions-instruction' style={{ marginTop: '-0.5rem' }}>
                <div className='add-fire-content-instructions-instruction-title'>Step 1: Create perimeter of fire (Optional)</div>
                <div className='add-fire-content-instructions-instruction-sub-title'>
                    Define a perimeter by plotting and connecting dots on the map.
                </div>
                {perimeter && (
                    <div className='create-area-content-form-btns'>
                        <div
                            className='create-area-content-form-btns-btn-save'
                            onClick={() => {
                                setPerimeter(null);
                                draw.current.deleteAll();
                            }}
                        >
                            Discard
                        </div>
                        <div
                            className='create-area-content-form-btns-btn-cancel'
                            onClick={() => {
                                setStage('fire-form');
                            }}
                        >
                            Next
                        </div>
                    </div>
                )}
                <div
                    style={{ marginTop: '0.7rem', cursor: 'pointer' }}
                    onClick={() => setStage('fire-form')}
                    className='add-fire-content-instructions-instruction-disabled-btn'
                >
                    Skip
                </div>
            </div>
        </div>
    );
}
